export const primary = '#26abe3';
export const primaryDark = '#008bcd';
export const primaryLight = '#8cceea';
export const disabled = '#e9eced';
export const dark = '#353d45';
export const grey = '#E8E8E9';
